import moment from "moment";
import React from "react";
import { useLocation } from "react-router-dom";

interface GroupByFuncProps<T> {
    (item: T): any
}
export const groupBy = <T>(
    list: T[],
    func: GroupByFuncProps<T>,
    keyValidator?: string,
) : [any, T[]][] => {
    const map: any[] = [];
    list.forEach((item) => {
        const key = func(item);
        let i = -1;
        map.forEach((mapItem, index) => {
            if (i === -1 && (
            (mapItem[0] === key)
            || (keyValidator && mapItem[0][keyValidator] === key[keyValidator])
            )) i = index;
        });
        if (i === -1) map.push([key, [item]]);
        else map[i][1].push(item);
    });
    return map;
};

export function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const extenseWeekday = (weekday) => [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
][weekday];

export const months = [
    "Janeiro",
    "Fevereiro",
    "Março",
    "Abril",
    "Maio",
    "Junho",
    "Julho",
    "Agosto",
    "Setembro",
    "Outubro",
    "Novembro",
    "Dezembro",
]

export const spentTime = dt => {
    const months = moment().diff(moment(dt), "months")
    const ds = moment().diff(moment(dt), "days")
    const hours = moment().diff(moment(dt), "hours")
    const minutes = moment().diff(moment(dt), "minutes")
    return months > 0
        ? `${months} meses atrás`
        : ds > 0
            ? `${ds} dias atrás`
            : hours > 0 ? `${hours} horas atrás` : `${minutes} minutos atrás`
}

export function useOnScreen(ref) {

    const [isIntersecting, setIntersecting] = React.useState(false)
  
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting)
    )
  
    React.useEffect(() => {
      observer.observe(ref.current)
      // Remove the observer as soon as the component is unmounted
      return () => { observer.disconnect() }
    }, [])
  
    return isIntersecting
  }


export const getEntityProfile = item => ({
    "senador": "Senador",
    "deputado_federal": "Deputado Federal",
    "deputado_distrital": "Deputado Distrital",
    "orgao": "Órgão",
}[item.type] || item.type);